import { autoinject } from "aurelia-framework";
import { RequestClientService } from "./request-client.service";
import { ConfigService } from "./config.service";
import { UserClientService } from "./user-client.service";
import { GetCustomerOfEntityResponse } from "../../models/customers/customer.models";

@autoinject()
export class CustomerService {

    private _baseUrl: string;
    private _getCustomerIdPromiseCache: Promise<number>;
    private _getBuIdPromiseCache: Promise<number>;

    constructor(private requestClient: RequestClientService, private configService: ConfigService, private userService : UserClientService) {
        this._baseUrl = this.configService.config.urls.rightShipPlatformApiUrl;
    }

    public getCustomerId(): Promise<number> {
        if(!this.userService.currentUser) {
            return new Promise<number>((resolve) => {
                resolve(null);
            });
        }
        else {
            if (!this._getCustomerIdPromiseCache) {
                this._getCustomerIdPromiseCache = this.requestClient.get<number>(`${this._baseUrl}/api/v1/customer/getCustomerId`, {});
            }
            return this._getCustomerIdPromiseCache;
        }
    }

    public getBusinessUnitId(): Promise<number> {
        if(!this.userService.currentUser) {
            return new Promise<number>((resolve) => {
                resolve(null);
            });
        }
        else {        
            if (!this._getBuIdPromiseCache) {
                this._getBuIdPromiseCache = this.requestClient.get<number>(`${this._baseUrl}/api/v1/customer/getBusinessUnitId`, {});
            }
            return this._getBuIdPromiseCache;
        }
    }

    public getCustomerOfEntityApproval(entityId: number, entityTypeId: number): Promise<GetCustomerOfEntityResponse> {
        return this.requestClient.get<GetCustomerOfEntityResponse>(`${this._baseUrl}/api/v1/customer/getCustomerOfEntityApproval`, { entityId: entityId, entityTypeId: entityTypeId });
    }
}
